const hooks = {};
function setupHooks(next) {
  Object.assign(hooks, next);
}
export { hooks, setupHooks };
//# sourceMappingURL=setupHooks.mjs.map
